var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./GetParcelNumberContainerTabs.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0a2933d0\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./GetParcelNumberContainerTabs.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./client/views/GetParcelNumberContainerTabs.vue
// module id = 892
// module chunks = 1